import React, { Fragment, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loader from "../Loading/loading";

import useMediaQuery from "../../Hooks/useMediaQuery";
import defaultLogo from "../../static/images/empcent_default.png";
import useOnceEffect from "../../Hooks/useOnceEffect";

function CarouselEmpresa({ id, isMobile, url = "access/list-company" }) {
  const [Courses, setEmpresas] = useState([]);
  const [indicators, setindicators] = useState([]);
  const [items, setitems] = useState([]);
  const [loading, setloading] = useState(true);
  isMobile = useMediaQuery("(max-width: 926px)");
  const qty = isMobile ? 1 : 3;
  let history = useHistory();

  useOnceEffect(() => {
    Carouselinner();
  });

  function Carouselinner() {
    axios.get(url).then((result) => {
      setEmpresas(result.data);
      LoadData(result.data);
    });
  }

  function LoadData(data) {
    let indice = 0;
    let step = parseInt(qty);

    let arrItems = [];

    for (let index = 0; index <= data.length - 1; index) {
      let arr = data.slice(index, step);

      let carItem = (
        <div
          key={Math.floor(Math.random() * 1000)}
          data-bs-interval="1000000"
          className={index == 0 ? "carousel-item active" : "carousel-item"}
          style={{ height: "100%" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "normal",
              justifyContent: "space-around",
              height: "100%",
              width: "95%",
            }}
          >
            {arr.map((item) => {
              return (
                <div
                  key={item.companyId}
                  className="card-item d-flex d-xl-inline-flex d-sm-flex p-3"
                >
                  <div className="card-container text-center text-sm-center  ">
                    <div className="card-logo border-gray">
                      <img
                        loading="lazy"
                        style={{ width: "100%", height: "100%" }}
                        src={
                          item.profileImagePath
                            ? item.profileImagePath
                            : defaultLogo
                        }
                      ></img>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "50%",
                        borderRadius: "0 0 25px 25px",
                        justifyContent: "space-between",
                        textAlign: "center",
                      }}
                    >
                      <p className="title">{item.name}</p>
                      <button
                        className="btn-deg"
                        onClick={() => setLink(item.companyId)}
                      >
                        Ver
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
      if (step + parseInt(qty) <= data.length) {
        index = step + 1;
        step += parseInt(qty) + 1;
      } else {
        index = step + 1;
        step = data.length;
      }
      indice++;
      arrItems.push(carItem);
    }
    setitems(arrItems);
    LoadIndicators(indice - 1);
    setloading(false);
  }

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={"" + index + ""}
          aria-label={"Slide " + (index + 1)}
          className={index == 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  function setLink(item) {
    let rol = localStorage.getItem("rol");

    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/PerfilEmpresa",
          state: { profileId: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/Empresa",
          state: { profileId: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Empresa",
          state: { profileId: item },
        });
        break;

      default:
        break;
    }
  }

  /*          <div className="carousel-indicators">{indicators}</div> */

  return (
    <div
      id={"carousel" + id}
      className={loading ? "loader_container" : "carousel slide"}
      data-interval="false"
      style={{ height: "300px", display: "flex", flexDirection: "column" }}
    >
      {loading ? (
        <Loader type="small"></Loader>
      ) : (
        <Fragment>
          <div className="carousel-inner" style={{ height: "100%" }}>
            {items}
          </div>

          <button
            className="carousel-control-prev"
            // style={sty}
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="prev"
          ></button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="next"
          ></button>
        </Fragment>
      )}
    </div>
  );
}

export default CarouselEmpresa;
